export function buildLeadTabPath(uid, newTab, designId, canvasScopeId) {
  const queryStart = newTab.indexOf('?');
  const tab = queryStart < 0 ? newTab : newTab.slice(0, queryStart);
  const params = new URLSearchParams(queryStart < 0 ? '' : newTab.slice(queryStart + 1));
  const cleanDesignId =
    typeof designId === 'string' ? designId.replace(/\/+$/, '') : '';
  const cleanCanvasId =
    typeof canvasScopeId === 'string' ? canvasScopeId.replace(/\/+$/, '') : '';
  if (cleanDesignId) params.set('design_id', cleanDesignId);
  if (cleanCanvasId && cleanDesignId && cleanCanvasId !== cleanDesignId) {
    params.set('canvas_id', cleanCanvasId);
  }
  const search = params.toString();
  return `/leads/${uid}/${tab}${search ? `?${search}` : ''}`;
}
